export default "__VITE_ASSET__977e9656__"